import { render } from "./EtatNombreProduitVendu.vue?vue&type=template&id=f67c1acc&ts=true"
import script from "./EtatNombreProduitVendu.vue?vue&type=script&lang=ts"
export * from "./EtatNombreProduitVendu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__